<template>
  <div>
    <div
      class="feed-post cursor radius-5"
      @click="$emit('open')"
      :style="
        `background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0),  rgba(0, 0, 0, .5)), url(` +
        feed.thumbnails.orig +
        `) center/cover;`
      "
    >
      <div class="feed-postedby" v-if="feed.posted_by">
        <InfluencerAvatar :user="feed.posted_by" />
        <div :class="[`profile-fullname`, feed.vello_export ? `truncate` : ``]">
          {{ feed.posted_by.full_name }}
        </div>
        <div
          class="feed-caption"
          :class="feed.vello_export ? `is-response` : ``"
          v-if="feed.vello_export"
        ></div>
      </div>
    </div>
    <div class="feed-actions text-semibold pt-2">
      <b-icon
        :icon="feed.is_liked ? `heart-fill` : `heart`"
        :class="[`cursor`, feed.is_liked ? `text-brand` : ``]"
        @click="toggleLikeFeed(feed)"
      ></b-icon>
      <span class="text-13 pl-2">{{ feed.total_likes }}</span>
    </div>
    <div class="feed-description pt-2 text-13">
      <div class="feed-tags py-1" v-if="feed.tags">
        <span class="feed-author text-semibold" v-if="feed.posted_by">
          <InfluencerProfileLink :user="feed.posted_by">
            @{{ feed.posted_by.username }}
          </InfluencerProfileLink>
        </span>
        <a
          href="#"
          class="text-gold text-semibold"
          v-for="(tag, key) in feed.tags"
          :key="key"
          :title="`Show posts with #${tag}`"
          @click.prevent="$emit('click-tag', tag)"
        >
          {{ `#` + tag }}
        </a>
      </div>
      <div v-if="feed.description">
        {{ feed.description }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import InfluencerAvatar from '@/views/components/User/InfluencerAvatar'
import InfluencerProfileLink from '@/views/components/User/InfluencerProfileLink'

export default {
  name: 'FeedCard',
  components: { InfluencerProfileLink, InfluencerAvatar },
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      video_src: null,
      video_poster: null,
    }
  },

  methods: {
    ...mapActions({
      toggleLikeFeed: 'feed/setunsetLikeFeed',
    }),
  },
}
</script>

<style lang="scss">
.feed-author a {
  color: #fff;

  &:hover {
    color: #ff0058;
    text-decoration: none;
  }
}
.feed-post {
  position: relative;
  transition: all 0.3s ease-in-out;

  .feed-postedby {
    width: 100%;
    position: absolute;
    left: 10px;
    bottom: 10px;
  }
  .rounded-circle {
    border: 2px solid rgba(0, 0, 0, 0.7);
    box-shadow: 0 0 0 2px #9f9f9f;
  }
  .profile-photo,
  .profile-fullname,
  .profile-vello {
    width: 20%;
    display: inline-block;
  }
  .profile-fullname {
    width: 35%;
    left: 15px;
    bottom: 18px;
    position: relative;
    font-size: 13px;

    &.truncate {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.feed-caption {
  &.is-response {
    &:before {
      content: '';
      background: url('~@/assets/img/vello-name.png') right/contain no-repeat;
      height: 20px;
      width: 100%;
      position: absolute;
      bottom: 8px;
      right: 20px;
      opacity: 0.5;
    }
  }
}
</style>
